export default {
    namespaced: true,

    state: () => ({
        dash: {
            darkMode: localStorage.getItem('theme') ? ( localStorage.getItem('theme') === 'dark' ? true : false) : false,
        },
    }),

    mutations: {
        STORE_DASH(state, reseller) {
            state.dash = reseller
        },

        USE_DARK_MODE(state) {
            state.dash.darkMode = !state.dash.darkMode
        },
    },

    actions: {},
};
